import { render, staticRenderFns } from "./dialogstat.vue?vue&type=template&id=4bd51213&scoped=true&lang=html"
import script from "./dialogstat.vue?vue&type=script&lang=js"
export * from "./dialogstat.vue?vue&type=script&lang=js"
import style0 from "./dialogstat.vue?vue&type=style&index=0&id=4bd51213&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd51213",
  null
  
)

export default component.exports